
export default {
  name: 'MainMenu',

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    MainMenuElement: () => import("./_MainMenuElement.vue"),
  },
}
